import React, { useState } from 'react';
import styled from 'styled-components';

import TabContent from '../common-components/Tab/TabContent';
import * as CatizColors from './Colors';
import { TabContentContainer, TabHeaderContainer } from './TabPanel';

const Container = styled.div`
  display: grid;
  grid-template-rows: 24px auto;
`;

const TabHead = styled.div<any>`
  padding: 4px 10px;
  border: solid 1px black;
  font-size: 12px;
  > span {
    cursor: pointer;
  }
  ${({ isActive }) => `
    border-bottom-style: ${isActive ? 'none' : 'solid'};
    background: ${isActive ? CatizColors.lightBlue : CatizColors.deepBlue}
  `}
`;

export function VideoContentTab(props) {
  const { tabHeaders, videoControls = true, defaultActiveTab } = props;
  const [activeTab, setActiveTab] = useState(
    defaultActiveTab ?? tabHeaders[0].id
  );
  const onClick = (item) => {
    setActiveTab(item.id);
  };

  const renderTabContent = (type, url) => {
    switch (type) {
      case 'image':
        return <img src={url} width="100%" height={'100%'} />;
      case 'video':
        return (
          <video
            src={url}
            controls={videoControls}
            width="100%"
            height={'100%'}
            autoPlay={true}
          />
        );
    }
  };

  return (
    <Container>
      <TabHeaderContainer>
        {tabHeaders.map((tabHead) => (
          <TabHead>
            <span id={tabHead} onClick={() => onClick(tabHead)}>
              {tabHead.label}
            </span>
          </TabHead>
        ))}
      </TabHeaderContainer>
      <TabContentContainer>
        {tabHeaders.map((tab) => (
          <TabContent key={tab.id} tabValue={tab.id} currValue={activeTab}>
            {renderTabContent(tab.type, tab.url)}
          </TabContent>
        ))}
      </TabContentContainer>
    </Container>
  );
}
